import AppTranslationService from './translation.service';

export default angular
    .module('MW.Framework.TranslationsModule', [])
    .service('AppTranslationService', AppTranslationService)
    .name;


/** WEBPACK FOOTER **
 ** ./public/ts/translation/translation.module.ts
 **/